<template>
    <div class="notifications" v-show="hasNotifications">
        <button
            type="button"
            class="notifications-button"
            :class="{ 'has-unread': unvisitedCount > 0 }"
            :aria-label="unvisitedCount > 0 ? 'Notificações: ' + unvisitedCount + ' não lidas' : 'Notificações'"
            :title="unvisitedCount > 0 ? 'Notificações (' + unvisitedCount + ')' : 'Notificações'"
            @click="open()"
        >
            <svg class="bell" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
            <span v-if="unvisitedCount > 0" class="badge">{{ unvisitedCount > 9 ? "9+" : unvisitedCount }}</span>
        </button>
        <div v-show="show" class="backdrop" @click="show = false"></div>

        <div :class="'popup ' + (show ? 'active' : '')">
            <div class="popup-body">
                <div class="alert alert-warning mb-2">
                    {{ t("user_notifications-beta_admin_only") }}
                </div>
                <div v-if="hasNotifications" class="list-notifications">
                    <div v-for="n in notifications" :key="n.id">
                        <button
                            :class="
                            'notification-text ' +
                            (n.is_visited === '0' ? 'new' : 'old')
                        "
                            @click="visit(n)"
                        >
                            <div v-if="n.is_visited === '0'">
                                <span class="far fa-circle"></span>
                            </div>
                            <div>
                                <div class="date">
                                    <human-date :date="n.created_at"/>
                                </div>
                                <div>
                                    {{
                                        $_(
                                            "user_notifications-" + n.template,
                                            n.params,
                                        )
                                    }}
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
                <div v-else>
                    <div>{{ t("user_notifications-no_notifications") }}</div>
                </div>
            </div>
            <div class="mark-read">
                <button class="ml-auto" @click.prevent="markAllVisited">{{ t("user_notifications-mark_all_read") }}</button>
            </div>
        </div>
    </div>
</template>
<style scoped lang="less">
// Sidebar expandida (230px): o sino fica na linha da marca, entre o logo e o botão de recolher
// (logo termina em ~144px; o botão de recolher ocupa 184-220px; linha centralizada em y = 50px).
.notifications {
    position: fixed;
    top: 34px;
    left: 150px;
    z-index: 100;
    transition: left .32s cubic-bezier(.22, 1, .36, 1), top .32s cubic-bezier(.22, 1, .36, 1);

    .notifications-button {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        padding: 0;
        border: 0;
        border-radius: 8px;
        background: transparent;
        color: #626473;
        cursor: pointer;
        transition: background-color .2s ease, color .2s ease;

        &:hover {
            background: #f3f3f6;
            color: #1f2337;
        }

        &:focus-visible {
            outline: 2px solid var(--primary, #4a3aff);
            outline-offset: 2px;
        }

        &.has-unread .bell {
            color: #1f2337;
        }
    }

    .badge {
        position: absolute;
        top: -3px;
        right: -4px;
        min-width: 16px;
        height: 16px;
        padding: 0 4px;
        border-radius: 999px;
        background: #f04438;
        color: #fff;
        font-size: 10px;
        font-weight: 700;
        line-height: 16px;
        text-align: center;
        box-shadow: 0 0 0 2px #fff;
        pointer-events: none;
    }

    .mark-read {
        width: 100%;
        padding: 10px;
        background: #f9f9f9;

        button {
            background: transparent;
            border: none;
            color: #626473;
            cursor: pointer;
        }
    }

    .backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: transparent;
        z-index: 999;

        &:before {
            content: "";
            position: absolute;
            top: 0;
            left: 230px;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
        }
    }

    // O popup abre ao lado da sidebar, não em cima dela.
    .popup {
        display: none;
        position: fixed;
        padding: 15px;
        left: 242px;
        top: 24px;
        width: 350px;
        border-radius: 8px;
        background-color: white;
        border: 1px solid #e5e6eb;
        box-shadow: 0 8px 24px rgba(16, 24, 40, 0.16);
        z-index: 1000;
        font-size: 14px;
        max-height: 70vh;
        overflow-y: auto;

        .list-notifications {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .notification-text {
                display: flex;
                gap: 10px;
                background: none;
                border: none;
                text-align: left;
                color: #aaa;

                &.new {
                    color: #444;
                }

                .date {
                    font-size: 11px;
                }

                .fa-circle {
                    font-size: 8px;
                }
            }
        }

        &.active {
            display: flex;
            flex-direction: column;
            justify-content: stretch;

            .popup-body {
                overflow-y: auto;
            }
        }
    }

    @media (max-width: 700px) {
        top: 10px;
        left: auto;
        right: 104px;

        .notifications-button {
            width: 36px;
            height: 36px;
            color: #fff;

            &:hover {
                background: rgba(255, 255, 255, 0.16);
                color: #fff;
            }

            &.has-unread .bell {
                color: #fff;
            }
        }

        .badge {
            box-shadow: 0 0 0 2px var(--primary, #4a3aff);
        }

        .backdrop {
            &:before {
                left: 0;
                top: 56px;
            }
        }

        .popup {
            position: fixed;
            left: 12px;
            right: 12px;
            top: 64px;
            width: auto;
            max-height: calc(100vh - 80px);
            max-height: calc(100dvh - 80px);
        }
    }
}
</style>
<style lang="less">
// Sidebar recolhida (60px): sino abaixo do botão de recolher (centralizado, 36px) e popup ao lado da barra.
// O menu desce para abrir espaço, senão o sino ficaria em cima do primeiro item.
@media (min-width: 701px) {
    body.sidebar-collapsed .notifications {
        top: 118px;
        left: 12px;

        .notifications-button {
            width: 36px;
            height: 36px;
        }

        .badge {
            box-shadow: 0 0 0 2px #fafafc;
        }

        .backdrop:before {
            left: 60px;
        }

        .popup {
            left: 72px;
            top: 110px;
            max-height: calc(100vh - 130px);
        }
    }

    body.sidebar-collapsed.has-notifications-bell .header .navbar-content {
        margin-top: 52px;
    }
}
</style>
<script>
import keviApi from "../../keviApi";
import HumanDate from "../../components/human-date/human-date";

export default {
    name: "userNotifications",
    components: {HumanDate},
    data() {
        return {
            notifications: [],
            timeout: null,
            unreadCount: 0,
            unvisitedCount: 0,
            show: false,
        };
    },
    created() {
        this.getNotifications();
    },
    beforeDestroy() {
        document.body.classList.remove("has-notifications-bell");
        window.clearTimeout(this.timeout);
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        hasNotifications() {
            return this.notifications.length > 0 && this.user.global_admin;
        },
        isLoginPage() {
            const currentPath = this.$route.path;
            return currentPath === "/";
        },
    },
    methods: {
        getLink(notification) {
            if (notification.source === "tasks") {
                const taskId = this.$route.query["task_id"];
                if (
                    taskId === notification.source_id &&
                    this.$route.path === "/tasks"
                ) {
                    return "";
                }
                return "/tasks?task_id=" + notification.source_id;
            }
            return "";
        },
        open() {
            this.show = true;
            const options = keviApi.getOptions("me/notifications/read", "POST");
            this.$http(options).then((response) => {
                this.unreadCount = response.data.unread_count;
            });
        },
        markAllVisited() {
            this.show = true;
            const options = keviApi.getOptions("me/notifications/visit-all", "POST");
            this.$http(options).then((response) => {
                this.getNotifications();
                this.unvisitedCount = response.data.unvisited_count;
            });
        },
        visit(notification) {
            const options = keviApi.getOptions(
                "me/notifications/" + notification.id + "/visit",
                "POST",
            );
            this.$http(options);
            const link = this.getLink(notification);
            this.$router.push(link);
            this.show = false;
            this.getNotifications();
        },
        getNotifications() {
            if (this.isLoginPage) {
                return;
            }

            const options = keviApi.getOptions("me/notifications");
            this.$http(options).then((response) => {
                this.notifications = response.data.notifications;
                this.unreadCount = response.data.unread_count;
                this.unvisitedCount = response.data.unvisited_count;
                window.clearTimeout(this.timeout);
                this.timeout = window.setTimeout(() => {
                    this.getNotifications();
                }, 1000*60*5); // 5 minutes
            });
        },
    },
    watch: {
        // Avisa o CSS da sidebar recolhida que há sino, para o menu abrir espaço abaixo dele.
        hasNotifications: {
            immediate: true,
            handler(visible) {
                document.body.classList.toggle("has-notifications-bell", !!visible);
            },
        },
        "$route"() {
            if (!this.isLoginPage) {
                this.getNotifications();
            }
        },
    },
};
</script>
